import {Column} from 'react-table'
import {Table} from '../../components'
import {useEffect, useState} from 'react'
import {getEvents} from '../../api/be'
import {KTSVG} from '../../../_metronic/helpers'
import {Tooltip} from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import moment from 'moment'
import {EventDetailModal} from './EventDetailModal'

type CustomColumn = {
  className?: string
} & Column

export const MainTable = () => {
  const [data, setData] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [showEventDetail, setShowEventDetail] = useState<boolean>(false)
  const [eventDetail, setEventDetail] = useState<any>({})

  const getEventsData = async () => {
    const res = await getEvents()

    res.data.sort((a: any, b: any) => b.featured - a.featured)
    setData(res.data)
    setLoading(false)
  }

  useEffect(() => {
    getEventsData().catch((err: any) => console.log(err))

    const intervalId = setInterval(() => {
      getEventsData().catch((err: any) => console.log(err))
    }, 30000)

    return () => clearInterval(intervalId)
  }, [])

  const handleEventDetailModal = (row: any) => {
    setEventDetail(row.original)
    setShowEventDetail(true)
  }

  const columns: CustomColumn[] = [
    {
      className: 'min-w-100px',
      Header: '  ',
      Cell: (cell: any) => {
        return (
          <span className='ps-4'>
            {cell.row.original?.imageUrl && (
              <img src={cell.row.original?.imageUrl} width={100} height={100} alt='' />
            )}
          </span>
        )
      },
    },
    {
      className: 'min-w-150px',
      Header: 'Title',
      accessor: 'title',
      Cell: (cell: any) => {
        return (
          <a href={cell.row.original.pageUrl} target='_blank' rel='noreferrer'>
            {cell.row.original.title}{' '}
            {cell.row.original.featured && (
              <>
                <KTSVG
                  path='/media/icons/duotune/general/gen003.svg'
                  className='svg-icon-1 svg-icon-main'
                />
              </>
            )}
          </a>
        )
      },
    },
    {
      className: 'min-w-150px',
      Header: 'Description',
      Cell: (cell: any) => {
        return (
          <>
            <span data-tooltip-id={'detail' + cell.row.original.id}>
              {cell.row.original.description.length > 20
                ? `${cell.row.original.description.substring(0, 20)}...`
                : cell.row.original.description}
            </span>
            <Tooltip id={'detail' + cell.row.original.id} content={cell.row.original.description} />
          </>
        )
      },
    },
    {
      className: 'min-w-200px',
      Header: 'From Date',
      accessor: 'fromDate',
      Cell: (cell: any) => {
        return <>{moment(cell.row.original.fromDate).format('YYYY/MM/DD LT')}</>
      },
    },
    {
      className: 'min-w-200px',
      Header: 'End Date',
      accessor: 'endDate',
      Cell: (cell: any) => {
        return <>{moment(cell.row.original.endDate).format('YYYY/MM/DD LT')}</>
      },
    },
    {
      className: 'min-w-100px',
      Header: 'Format',
      accessor: 'format',
    },
    {
      className: 'min-w-100px',
      Header: 'City',
      accessor: 'city',
    },
    {
      className: 'min-w-100px',
      Header: 'Region',
      accessor: 'region',
    },
    {
      className: 'min-w-100px',
      Header: 'Main',
      accessor: 'mainSide',
      Cell: (cell: any) => {
        return (
          <>
            {cell.row.original.mainSide && (
              <>
                <KTSVG path='/media/icons/duotune/general/gen072.svg' className='svg-icon-1' />
              </>
            )}
          </>
        )
      },
    },
    {
      className: 'min-w-100px',
      Header: 'Recording',
      accessor: 'record',
      Cell: (cell: any) => {
        return (
          <>
            {cell.row.original.record && (
              <>
                <KTSVG path='/media/icons/duotune/general/gen072.svg' className='svg-icon-1' />
              </>
            )}
          </>
        )
      },
    },
  ]

  return (
    <>
      <Table
        className='mb-5 mb-xl-10'
        title=' '
        columns={columns}
        data={data}
        isLoading={loading}
        pageSize={100}
        onRowClick={(row: any) => handleEventDetailModal(row)}
      ></Table>

      <EventDetailModal
        data={eventDetail}
        setShowEventDetail={setShowEventDetail}
        showEventDetail={showEventDetail}
      />
    </>
  )
}
